import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ConfirmationModal, Typography, useOverlayContext } from 'seagull';
import { SecureLoginModal } from "../SecureLoginModal/SecureLoginModal";
import styles from "../SecureLoginModal/SecureLoginModal.module.scss";
import { routes } from "../../constants";
import { useFeatureFlags } from "../../hooks/useFeatureFlags";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const LoginErrorModal = () => {
  const overlayContext = useOverlayContext();
  const history = useHistory();
  const location = useLocation();
  const {
    SET_IDENTITY_ONLY_TOKEN_FE
  } = useFeatureFlags();
  useEffect(() => {
    const baseRoute = location.pathname.replace(routes.loginError, '');
    let updatedDismissModal;
    overlayContext.showModal({
      content: _ref => {
        let {
          dismissModal
        } = _ref;
        updatedDismissModal = dismissModal;
        return /*#__PURE__*/_jsx(ActualLoginErrorModal, {
          dismissModal: updatedDismissModal
        });
      },
      closeOnClickOutside: true,
      closeOnEscapeKey: true
    }).then(shouldOpenSecureLogin => {
      history.replace(baseRoute);
      if (shouldOpenSecureLogin && !SET_IDENTITY_ONLY_TOKEN_FE) {
        overlayContext.showModal({
          content: _ref2 => {
            let {
              dismissModal
            } = _ref2;
            return /*#__PURE__*/_jsx(SecureLoginModal, {
              dismissModal: dismissModal
            });
          },
          closeOnClickOutside: true,
          closeOnEscapeKey: true
        });
      }
    });
    return () => {
      if (updatedDismissModal) {
        updatedDismissModal(false);
      }
    };
  }, []);
  return null;
};
export const ActualLoginErrorModal = _ref3 => {
  let {
    dismissModal
  } = _ref3;
  const {
    SET_IDENTITY_ONLY_TOKEN_FE
  } = useFeatureFlags();
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    testId: "login-error-modal",
    title: "Something went wrong",
    content: /*#__PURE__*/_jsxs("div", {
      className: styles.secureLoginModalContainer,
      children: [/*#__PURE__*/_jsx(Typography, {
        children: "The email address associated with this account is different from the one you tried to login with."
      }), /*#__PURE__*/_jsx(Typography, {
        children: "To set up a secure login, you must use the same email address."
      }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx(Typography, {
        children: "You can always open a Service Provider account using a different email address through www.sayanchor.com"
      })]
    }),
    onCloseButtonClick: () => dismissModal(false),
    primaryButtonLabel: SET_IDENTITY_ONLY_TOKEN_FE ? '' : 'Go back to login',
    onPrimaryButtonClick: () => dismissModal(true),
    secondaryButtonLabel: SET_IDENTITY_ONLY_TOKEN_FE ? 'Back' : 'Cancel',
    onSecondaryButtonClick: () => dismissModal(false)
  });
};